var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessConnectCheque(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 120,
    viewBox: "0 0 222 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14236_73296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.696 0H82.3037C77.8964 1.77698e-06 73.5667 1.15842 69.7498 3.35883C65.933 5.55924 62.7635 8.7241 60.5598 12.5353L40.3638 47.4644C38.1601 51.2756 37 55.5989 37 59.9997C37 64.4005 38.1601 68.7238 40.3638 72.535L60.5598 107.465C62.7635 111.276 65.933 114.441 69.7498 116.641C73.5667 118.842 77.8964 120 82.3037 120H122.696C127.104 120 131.433 118.842 135.25 116.641C139.067 114.441 142.237 111.276 144.44 107.465L164.636 72.535C166.84 68.7238 168 64.4005 168 59.9997C168 55.5989 166.84 51.2756 164.636 47.4644L144.44 12.5353C142.237 8.7241 139.067 5.55924 135.25 3.35883C131.433 1.15842 127.104 1.77698e-06 122.696 0Z",
    fill: "url(#paint0_linear_14236_73296)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2014 4C52.2244 6.76423 49.5882 8.74468 46.4894 8.74468C43.3906 8.74468 40.7543 6.76423 39.7773 4H37V115.5H39.7773C40.7543 112.736 43.3906 110.755 46.4894 110.755C49.5882 110.755 52.2244 112.736 53.2014 115.5H63.5007C64.4777 112.736 67.114 110.755 70.2128 110.755C73.3116 110.755 75.9478 112.736 76.9248 115.5H87.2241C88.2011 112.736 90.8374 110.755 93.9362 110.755C97.035 110.755 99.6712 112.736 100.648 115.5H103.426V4H100.648C99.6712 6.76423 97.035 8.74468 93.9362 8.74468C90.8374 8.74468 88.2011 6.76423 87.2241 4H76.9248C75.9478 6.76423 73.3116 8.74468 70.2128 8.74468C67.114 8.74468 64.4777 6.76423 63.5007 4H53.2014Z",
    fill: "white",
    stroke: "#C7C7CC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2961 23.1719L82.0742 23.1719",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2961 99.5371L82.0742 99.5371",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6855 45.6885L93.6855 45.6885",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6855 61.4336L93.6855 61.4336",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6855 77.5727L93.6855 77.5728",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.574,
    y: -0.148951,
    width: 60.5141,
    height: 106.113,
    rx: 7,
    transform: "rotate(20 121.574 -0.148951)",
    fill: "white",
    stroke: "#254E5F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_14236_73296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.184,
    cy: 13.115,
    rx: 1.56285,
    ry: 1.55932,
    transform: "rotate(20 141.184 13.115)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.184,
    cy: 13.115,
    rx: 1.56285,
    ry: 1.55932,
    transform: "rotate(20 141.184 13.115)",
    fill: "#254E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.774 12.9655C140.858 12.7328 141.112 12.6198 141.335 12.7009L139.967 16.4597C141.812 17.1312 143.859 16.1848 144.532 14.3336L140.774 12.9655ZM141.335 12.7009C141.558 12.782 141.68 13.0318 141.595 13.2646L137.836 11.8965C137.163 13.7477 138.122 15.7882 139.967 16.4597L141.335 12.7009ZM141.595 13.2646C141.51 13.4973 141.256 13.6103 141.034 13.5291L142.402 9.77038C140.557 9.09884 138.51 10.0453 137.836 11.8965L141.595 13.2646ZM141.034 13.5291C140.811 13.448 140.689 13.1982 140.774 12.9655L144.532 14.3336C145.206 12.4824 144.247 10.4419 142.402 9.77038L141.034 13.5291Z",
    fill: "#254E5F",
    mask: "url(#path-9-inside-1_14236_73296)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.611,
    y: 13.8963,
    width: 10.9435,
    height: 1.55932,
    rx: 0.779658,
    transform: "rotate(20 145.611 13.8963)",
    fill: "#254E5F",
    stroke: "#254E5F",
    strokeWidth: 1.55932
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_14236_73296)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.683,
    cy: 104.503,
    rx: 4.1676,
    ry: 4.15818,
    transform: "rotate(20 115.683 104.503)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.659 105.586C118.063 107.223 116.248 108.07 114.602 107.471C112.956 106.872 112.11 105.057 112.706 103.42C113.302 101.783 115.117 100.936 116.763 101.535C118.409 102.134 119.255 103.949 118.659 105.586Z",
    stroke: "#254E5F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_14236_73296)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.422,
    y: 11.7322,
    width: 54.7436,
    height: 82.9332,
    rx: 4,
    transform: "rotate(20 120.422 11.7322)",
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.02,
    y: 13.0139,
    width: 52.7436,
    height: 80.9332,
    rx: 3,
    transform: "rotate(20 121.02 13.0139)",
    stroke: "#254E5F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.504,
    cy: 59.957,
    r: 15.4525,
    transform: "rotate(20 131.504 59.957)",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.617 56.7436L128.459 64.7923L126.2 58.5866",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_14236_73296",
    x: 111.515,
    y: 100.343,
    width: 8.33594,
    height: 10.3208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14236_73296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14236_73296",
    x: 93.1826,
    y: 12.8579,
    width: 77.5557,
    height: 95.4036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14236_73296"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14236_73296",
    x1: 37,
    y1: 120,
    x2: 156.54,
    y2: -10.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA1A5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14236_73296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessConnectCheque);
export default __webpack_public_path__ + "static/media/success_connect_cheque.eac38eabf20647755f201a6867578c59.svg";
export { ForwardRef as ReactComponent };